import React from 'react';
import { uniqueId } from 'lodash';
import { Icon } from 'ui';
import ActivityItem from './ActivityItem';

const ActivityFeedDateContainer = ({ i18n, date, activitiesByDate }) => (
  <div className="ActivityFeed-dateContainer mb-8">
    <div className="mb-8">
      <Icon name="calendar_empty" className="ActivityFeed-icon" />
      <span className="ActivityFeed-date ml-8">{date}</span>
    </div>
    {activitiesByDate[date].map(latestActivity => (
      <ActivityItem
        key={uniqueId(latestActivity.user)}
        i18n={i18n}
        user={latestActivity.user}
        activity={latestActivity.activity}
        actionable={latestActivity.actionable}
      />
    ))}
  </div>
);

export default ActivityFeedDateContainer;
